import { Typography, Modal, useModalContext, Button } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

export const FeedbackModalContent = () => {
  const { closeModal } = useModalContext();
  const { t } = useI18n();

  return (
    <Modal data-testid="feedback-modal">
      <Modal.Header title="users:share_feedback" />
      <Modal.Content>
        <Typography>
          {t('users:share_feedback_description')}{' '}
          <a href="mailto:contact@appvelocity.io" target="__blank">
            contact@appvelocity.io
          </a>
        </Typography>
      </Modal.Content>
      <Modal.Controls>
        <Button
          onClick={() => closeModal()}
          color="secondary"
          variant="contained"
        >
          {t('shared:cancel')}
        </Button>
      </Modal.Controls>
    </Modal>
  );
};
